export const zoneIdSubTopicMap: { [key: string]: string } = {
  skatmasters: 'skaMasters',
  skat: 'skaMasters',
  romme: 'romTournament',
  rommemasters: 'romTournament',
}

// copied from customer-service-form -module
export interface CsFormPreselections {
  topic?: string //#{cc.attrs.topic}
  subTopic?: string //#{cc.attrs.subTopic}
  message?: string //#{cc.attrs.prefillText}
  gameType?: string //#{cc.attrs.gameType}
  competitionId?: string //#{cc.attrs.competitionId}
}

export function getSubTopic(zoneId: string) {
  return (zoneId && zoneIdSubTopicMap[zoneId.replace('_gd', '')]) || 'duel'
}
